var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomVideoFile = function SvgCustomVideoFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.172 3H9c-1.886 0-2.828 0-3.414.586C5 4.172 5 5.114 5 7v10c0 1.886 0 2.828.586 3.414C6.172 21 7.114 21 9 21h6c1.886 0 2.828 0 3.414-.586C19 19.828 19 18.886 19 17V8.828c0-.408 0-.613-.076-.796-.076-.184-.22-.329-.51-.618l-3.828-3.828c-.29-.29-.434-.434-.617-.51C13.785 3 13.58 3 13.171 3Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.673 12.717-.394.919.394-.92Zm3.182 1.364.394-.92-.394.92Zm0 1.838.394.92-.394-.92Zm-3.182 1.364-.394-.919.394.92Zm-.394-3.647L13.46 15l.788-1.838-3.182-1.364-.788 1.838ZM13.46 15l-3.182 1.364.788 1.838 3.182-1.364L13.461 15ZM8 13.82v2.36h2v-2.36H8Zm2.279 2.544A.2.2 0 0 1 10 16.18H8a2.2 2.2 0 0 0 3.067 2.022l-.788-1.838ZM13.46 15l.788 1.838c1.617-.692 1.617-2.984 0-3.676L13.461 15Zm-2.394-3.202A2.2 2.2 0 0 0 8 13.82h2a.2.2 0 0 1 .279-.184l.788-1.838Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3v4c0 .943 0 1.414.293 1.707C13.586 9 14.057 9 15 9h4",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};

export default SvgCustomVideoFile;